export default {"src":"/_next/static/media/Learn_more_services.ef3320aa.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};